export const skillsSelector = (state) => state.skills.skills;
export const skillSelector = (state) => state.skills.skills;
